import * as spriteConfig from './sprites.config';
import * as soundConfig from './sounds.config';

/** COMMON ATTRIBUTES DECLARATION **/

export const common: any = {
  additional: {
    fixed: {
      allowedRotationAngle: 10,
      lookSpeed: 30,
    },
    gimballed: {
      allowedRotationAngle: 60,
      aboveShip: true,
      lookSpeed: 45,
    },
    turret360: {
      allowedRotationAngle: 360,
      aboveShip: true,
      lookSpeed: 45,
    },
  },

  weaponParams: {
    beam: {
      width: 11 / 4,
      height: 57 / 4,
      range: 1000,
      timeBetweenShots: 200,
    },
    laser: {
      width: 11 / 4,
      height: 57 / 4,
      range: 1000,
      timeBetweenShots: 20,
    },
    missileLauncher: {
      width: 11 / 4,
      height: 57 / 4,
      range: 1000,
      timeBetweenShots: 500,
      ammo: 4,
      timeBetweenReloads: 2000,
    }
  },
};

common.projectileParams = {
  beam: {
    width: 9 / 2,
    height: 37 / 2,
    moveSpeed: 1500,
    damage: 25 * common.weaponParams.beam.timeBetweenShots / 1000, // 25 DPS
  },
  laser: {
    width: 9 / 4,
    height: 37 / 2,
    moveSpeed: 1000,
    damage: 25 * common.weaponParams.laser.timeBetweenShots / 1000, // 25 DPS
  },
  missile: {
    width: 50 / 5,
    height: 252 / 5,
    moveSpeed: 250,
    explosionRadius: 250,
    damage: 50 * common.weaponParams.missileLauncher.timeBetweenShots / 1000, // 50 DPS in AOE
  }
};

/** INDIVIDUAL WEAPONS CONFIGURATION **/

export const jetCannon = {
  ...common.weaponParams.beam,
  ...common.additional.fixed,
  spriteParams: {...spriteConfig.weapons.basicWeapon},
  projectileParams: {
    ...common.projectileParams.beam,
  },
  soundParams: {...soundConfig.weapons.pew}
};

export const missileLauncher = {
  ...common.weaponParams.missileLauncher,
  spriteParams: {...spriteConfig.projectiles.rocket},
  projectileParams: {
    ...common.projectileParams.missile,
  },
  soundParams: {...soundConfig.weapons.pew}
};

export const destroyerCannon = {
  ...common.weaponParams.beam,
  ...common.additional.fixed,
  width: common.weaponParams.beam.width * 3,
  height: common.weaponParams.beam.height * 3,
  timeBetweenShots: common.weaponParams.beam.timeBetweenShots * 3,
  spriteParams: {...spriteConfig.weapons.basicWeapon},
  projectileParams: {
    ...common.projectileParams.beam,
    width: common.projectileParams.beam.width * 3,
    height: common.projectileParams.beam.height * 3,
    damage: common.projectileParams.beam.damage * 3,
  },
  soundParams: {...soundConfig.weapons.blam}
};

export const destroyerCannonBoradside = {
  ...destroyerCannon,
  allowedRotationAngle: 15,
};

export const destroyerTurret = {
  ...common.weaponParams.beam,
  ...common.additional.gimballed,
  spriteParams: {...spriteConfig.weapons.basicWeapon},
  projectileParams: {
    ...common.projectileParams.beam,
  },
  soundParams: {...soundConfig.weapons.pew}
};

export const laserTurret = {
  ...common.weaponParams.laser,
  ...common.additional.gimballed,
  spriteParams: {...spriteConfig.weapons.basicWeapon},
  projectileParams: {
    ...common.projectileParams.laser,
  }
};

export const miningLaser = {
  ...common.weaponParams.laser,
  ...common.additional.turret360,
  spriteParams: {...spriteConfig.weapons.basicWeapon},
  projectileParams: {
    ...common.projectileParams.laser,
    spriteParams: {...spriteConfig.projectiles.greenBeam},
    damage: common.projectileParams.laser.damage * 4,
  },
};

export const basicTurret = {
  ...common.weaponParams.beam,
  ...common.additional.turret360,
  width: common.weaponParams.beam.width * 2,
  height: common.weaponParams.beam.height * 2,
  spriteParams: {...spriteConfig.weapons.basicWeapon},
  projectileParams: {
    ...common.projectileParams.beam,
    width: common.projectileParams.beam.width * 2,
    height: common.projectileParams.beam.height * 2,
    damage: common.projectileParams.beam.damage * 2,
  },
};

export const basicTurretEnemy = {
  ...basicTurret,
  projectileParams: {
    ...basicTurret.projectileParams,
  },
};